import { useState, useEffect } from "react";

export function CinematicEntrance({ children }) {
  const [phase, setPhase] = useState("black"); // black → line → split → reveal → done

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("line"), 300);
    const t2 = setTimeout(() => setPhase("split"), 1400);
    const t3 = setTimeout(() => setPhase("reveal"), 2000);
    const t4 = setTimeout(() => setPhase("done"), 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, []);

  const isRevealed = phase === "reveal" || phase === "done";

  return (
    <>
      {children}

      {/* Overlay curtain — always in DOM, hidden when done */}
      {phase !== "done" && (
        <div
          className="fixed inset-0 z-[10000] flex items-center justify-center"
          style={{
            backgroundColor: "#0a0a0a",
            opacity: isRevealed ? 0 : 1,
            pointerEvents: isRevealed ? "none" : "auto",
            transition: "opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1)",
          }}
        >
          {/* Gold horizontal line */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              height: "1px",
              backgroundColor: "#9E8A5A",
              transform: "translateX(-50%)",
              transition: "width 0.9s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.4s ease",
              width: phase === "black" ? "0px" : phase === "line" ? "120px" : "0px",
              opacity: phase === "split" || isRevealed ? 0 : 0.7,
            }}
          />
        </div>
      )}
    </>
  );
}
